class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.mainSliderEl = this.querySelector('.product-media__main-slider');
    this.thumbnailSliderEl = this.querySelector('.product-media__thumbnails-slider');

    if (!this.mainSliderEl || !this.thumbnailSliderEl) {
      return;
    }

    const mainReady = this.#whenSliderReady(this.mainSliderEl);
    const thumbReady = this.#whenSliderReady(this.thumbnailSliderEl);

    Promise.all([mainReady, thumbReady]).then(([mainSwiper, thumbSwiper]) => {
      mainSwiper.params.thumbs.swiper = thumbSwiper;
      mainSwiper.thumbs.init(mainSwiper.params.thumbs);
      mainSwiper.thumbs.update(true);
    });

    this.thumbnailSliderEl.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (this.mainSliderEl.swiper) {
          this.mainSliderEl.swiper.slideToLoop(index);
        }
      });
    });
  }

  #whenSliderReady(sliderEl) {
    return new Promise((resolve) => {
      const check = () => {
        if (sliderEl.swiper) {
          resolve(sliderEl.swiper);
          return true;
        }
        return false;
      };

      if (check()) return;

      const observer = new MutationObserver(() => {
        if (check()) {
          observer.disconnect();
        }
      });

      observer.observe(sliderEl, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    });
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
} 